<template>
  <div class="block-form">
    <v-btn text @click="dialog = true">
      <v-icon class="mr-1">{{ buttonIcon }}</v-icon> {{ buttonLabel }}
    </v-btn>

    <v-dialog v-if="faq" v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ buttonLabel }} ?</v-card-title>

        <v-card-text
          >Are you sure you want to {{ buttonLabel.toLowerCase() }} this FAQ
          ?</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="dialog = false" :loading="form.$busy"
            >Cancel</v-btn
          >

          <v-btn color="red" text @click="onSubmit" :loading="form.$busy"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show = false">OK</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Block/Unblock form
 * ==================================================================================
 **/

import { mapActions } from 'vuex'
import { mdiLock, mdiLockOpen } from '@mdi/js'
import Faq from '@/models/Faq'
import Form from '@/utils/form'

export default {
  props: {
    faq: {
      type: [Faq, Object]
    }
  },

  data() {
    return {
      icons: {
        block: mdiLock,
        unblock: mdiLockOpen
      },
      form: new Form(),
      dialog: false,

      snackbar: {
        show: false,
        message: null,
        color: ''
      }
    }
  },

  computed: {
    buttonLabel() {
      return `${this.isBlocked ? 'Enable' : 'Disable'}`
    },

    buttonState() {
      return this.isBlocked ? 'primary' : 'red'
    },

    buttonIcon() {
      return this.isBlocked ? this.icons.unblock : this.icons.block
    },

    isBlocked() {
      return this.faq ? !this.faq.active : false
    }
  },

  methods: {
    ...mapActions({
      updateFaq: 'faq/updateFaq'
    }),

    async onSubmit() {
      if (this.form.$busy) return
      this.form.$setLoading(true)

      let message = `FAQ successfully ${this.buttonLabel.toLowerCase()}d!`
      await this.updateFaq({
        id: this.faq.id,
        active: !this.faq.active
      })
        .then(data => {
          this.form.$setLoading(false)
          this.dialog = false

          this.showSnackbar(message, 'success')
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
          this.showSnackbar(this.form.$errorMessage, 'danger')
        })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  }
}
</script>
